import {
  DELETED_TABLE_DATA,
  DOC_LEVEL_DATA,
  LOADER_STATUS,
  PROCESSED_TABLE_DATA,
  SUMMARY_TABLE_DATA,
  TOTAL_PAGES_DELETED,
  TOTAL_PAGES_PROCESSED,
} from "./constants";

export const initialState = {
  loaderStatus: false,
  summaryTableData: [],
  processedTableData: [],
  deletedTableData: [],
  docLevelData: [],
  totalPagesProc: 1,
  totalPagesDel: 1,
};

/* eslint-disable default-case, no-param-reassign */
const gstr2a2bNewViewReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus,
      };
    case SUMMARY_TABLE_DATA:
      return {
        ...state,
        summaryTableData: action.summaryTableData,
      };
    case PROCESSED_TABLE_DATA:
      return {
        ...state,
        processedTableData: action.processedTableData,
      };
    case DELETED_TABLE_DATA:
      return {
        ...state,
        deletedTableData: action.deletedTableData,
      };
    case DOC_LEVEL_DATA:
      return {
        ...state,
        docLevelData: action.docLevelData,
      };
    case TOTAL_PAGES_PROCESSED:
      return {
        ...state,
        totalPagesProc: action.totalPagesProc,
      };
    case TOTAL_PAGES_DELETED:
      return {
        ...state,
        totalPagesDel: action.totalPagesDel,
      };
    default:
      return state;
  }
};

export default gstr2a2bNewViewReducer;
